import React, { lazy } from 'react';
import { Utensils } from 'lucide-react';
export function SignatureDishes() {
  const dishes = [{
    name: 'Irish Stew',
    description: 'Hearty lamb stew with root vegetables, slow-cooked to perfection.',
    image: 'https://oldmillrestaurant.ie/wp-content/uploads/photo-gallery/imported_from_media_libray/Fish.jpg?bwg=1552489513',
    hasImage: true
  }, {
    name: 'Famous Wicklow Lamb Shank',
    description: 'Tender slow-braised lamb shank with rosemary jus and creamy mash.',
    image: 'https://oldmillrestaurant.ie/wp-content/uploads/photo-gallery/imported_from_media_libray/dessert-2.jpg?bwg=1552644514',
    hasImage: true
  }, {
    name: 'Dublin Coddle',
    description: 'A Dublin classic — sausages, bacon, and potatoes in a rich broth.',
    hasImage: false
  }, {
    name: 'Cottage Pie',
    description: 'Seasoned beef mince topped with golden mashed potato.',
    hasImage: false
  }, {
    name: 'Beef & Guinness Stew',
    description: 'Rich, dark stew braised with Guinness and fresh herbs.',
    hasImage: false
  }];
  return <section id="dishes" className="py-20 md:py-24 bg-background relative" data-id="element-269">
      <div className="container mx-auto px-4" data-id="element-270">
        <div className="text-center mb-16" data-id="element-271">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-foreground mb-4 relative inline-block" data-id="element-272">
            Signature Dishes
            <span className="absolute -bottom-2 left-0 right-0 h-1 bg-primary rounded-full opacity-80" data-id="element-273"></span>
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl mt-6" data-id="element-274">
            Taste the best of Ireland
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-275">
          {dishes.map((dish, index) => <div key={index} className={`group relative overflow-hidden rounded-lg bg-card border border-border hover:border-primary transition-all duration-300 hover:shadow-[0_0_20px_rgba(var(--primary),0.15)] ${!dish.hasImage ? 'flex flex-col justify-center p-8 min-h-[240px]' : ''}`} data-id="element-276">
              {dish.hasImage ? <>
                  <div className="aspect-[4/3] overflow-hidden" data-id="element-277">
                    <img src={dish.image} alt={dish.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-278" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-80 group-hover:opacity-70 transition-opacity" data-id="element-279"></div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-280">
                    <h3 className="font-serif text-2xl font-bold text-white mb-2 group-hover:text-primary transition-colors" data-id="element-281">
                      {dish.name}
                    </h3>
                    <p className="text-gray-200 text-sm md:text-base line-clamp-2" data-id="element-282">
                      {dish.description}
                    </p>
                  </div>
                </> : <div className="text-center h-full flex flex-col items-center justify-center" data-id="element-283">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors" data-id="element-284">
                    <Utensils className="w-6 h-6 text-primary" data-id="element-285" />
                  </div>
                  <h3 className="font-serif text-2xl font-bold text-foreground mb-3 group-hover:text-primary transition-colors" data-id="element-286">
                    {dish.name}
                  </h3>
                  <p className="text-muted-foreground" data-id="element-287">{dish.description}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}